/**
 * Coloured pill for a bill's primary (top-level) category
 */

import React from 'react';

const FALLBACK_COLOR = '#6366f1';

function hexToRgba(hex: string, alpha: number): string {
  let sanitized = hex.trim().replace('#', '');
  if (sanitized.length === 3) {
    sanitized = sanitized.split('').map((c) => c + c).join('');
  }
  const num = parseInt(sanitized, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

interface PrimaryCategoryChipProps {
  name: string;
  color?: string;
}

export function PrimaryCategoryChip({ name, color }: PrimaryCategoryChipProps): React.ReactElement {
  const displayColor = color || FALLBACK_COLOR;
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{ backgroundColor: hexToRgba(displayColor, 0.16), color: displayColor }}
    >
      {name}
    </span>
  );
}
